import { render, staticRenderFns } from "./sendDetail.vue?vue&type=template&id=41db6356&scoped=true&"
import script from "./sendDetail.vue?vue&type=script&lang=js&"
export * from "./sendDetail.vue?vue&type=script&lang=js&"
import style0 from "./sendDetail.vue?vue&type=style&index=0&id=41db6356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db6356",
  null
  
)

export default component.exports